module.exports = __webpack_public_path__ + "img/kz.a3cd7cd6.jpg";